@if (isOtherLoading()) {
  <mat-progress-bar class="global-topbar" mode="indeterminate"></mat-progress-bar>
}

<router-outlet />

@if (isManagedLoading()) {
  <div class="global-overlay" role="alert" aria-live="assertive" aria-busy="true">
    <div class="global-overlay__panel">
      <div class="global-overlay__cubes" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p class="global-overlay__label">Loading…</p>
    </div>
  </div>
}

<app-toast-alert></app-toast-alert>
